module.exports = __webpack_public_path__ + "assets/img/placeholder/infographie-recherche.svg";